import { LoadingSkeleton } from '@/components/LoadingSkeleton/LoadingSkeleton'

export default function ConnectedAccountsLoadingRow() {
  return (
    <div className="flex items-center gap-4 px-4 py-4" aria-busy="true" aria-label="Loading connected accounts">
      <div className="h-[60px] w-[60px] shrink-0 rounded-md border border-brand-neutral-200 bg-brand-neutral-50 p-3">
        <LoadingSkeleton width="100%" lineHeight="100%" />
      </div>
      <div className="min-w-0 flex-1 space-y-2">
        <LoadingSkeleton width="100%" lineHeight="1rem" />
      </div>
      <LoadingSkeleton width={96} lineHeight="1.25rem" />
    </div>
  )
}
